/* geschirr-finder-v4.js | Geschirr-Finder v8 (100%-Spec: System/Daten + UX + Visual + Motion)
   Zwei Maschinen: resolvePhysical() (Körper -> Familie+Größe, harter Gate, Überlappung 55,5-62,7cm)
   + Bedarfs-Profil (sichtbar, Integer-needs; kippt die Familie NUR in der Überlappung, nur problem-getrieben).
   Befund liest S2-Antworten + dominanten Hebel. Out-of-Range-Messungen (unter 26,7 / über 92 cm) = ehrliche Schiene.
   Tracking: nur Enums/Buckets (nie roher cm/kg, nie E-Mail). Kein %-Score. G1 kein Auslaufmodell. Echte Umlaute. */
(function () {
  'use strict';
  var FUNNEL = { funnel_id: 'geschirr-finder', funnel_version: 'v8', source_page: 'pages/geschirr-finder' };
  var RM = false; try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e0) {}
  var SIZES = [
    ['3XS', 1.5, 3.0, 26.7, 30.1], ['2XS', 2.0, 4.0, 30.2, 33.8], ['XS', 3.5, 5.5, 33.9, 38.2],
    ['S', 4.5, 8.0, 38.3, 43.3], ['M', 6.5, 10.5, 43.4, 49.0], ['L', 9.0, 13.0, 49.1, 55.4],
    ['XL', 11.5, 18.0, 55.5, 62.7], ['2XL', 16.5, 24.0, 62.8, 70.1], ['3XL', 22.0, 31.0, 70.2, 78.9],
    ['4XL', 28.0, 48.0, 79.0, 92.0]
  ];
  var SIZE_TO_VARIANT = { '3XS': 'XXXS', '2XS': 'XXS' };
  function variantSizeCode(l) { return SIZE_TO_VARIANT[l] || l; }
  function famFromWeight(kg) { if (kg == null) return null; if (kg > 18) return 'comfort'; if (kg >= 11.5) return 'overlap'; return 'amp'; }
  function famFromChest(cm) { if (cm > 62.7) return 'comfort'; if (cm >= 55.5) return 'overlap'; return 'amp'; }
  function sizeIdx(l) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i][0] === l) return i; return -1; }
  function chestToSize(cm) {
    if (cm < SIZES[0][3]) return SIZES[0][0];
    if (cm > SIZES[SIZES.length - 1][4]) return SIZES[SIZES.length - 1][0];
    for (var i = 0; i < SIZES.length; i++) if (cm >= SIZES[i][3] && cm <= SIZES[i][4]) return SIZES[i][0];
    for (var j = 0; j < SIZES.length; j++) if (cm < SIZES[j][3]) return SIZES[j][0];
    return SIZES[SIZES.length - 1][0];
  }
  function roughSize(kg, bau) {
    if (kg == null) return null;
    if (kg < SIZES[0][1]) return '3XS'; if (kg > SIZES[SIZES.length - 1][2]) return '4XL';
    var m = []; for (var i = 0; i < SIZES.length; i++) if (kg >= SIZES[i][1] && kg <= SIZES[i][2]) m.push(SIZES[i]);
    if (!m.length) { for (var g = 0; g < SIZES.length; g++) if (kg < SIZES[g][1]) return SIZES[g][0]; return '4XL'; }
    if (m.length === 1) { var rec = m[0]; if ((bau === 'kraeftig' || bau === 'tief_schmal') && (rec[2] - kg) < 0.5) { var k = sizeIdx(rec[0]); if (SIZES[k + 1]) rec = SIZES[k + 1]; } return rec[0]; }
    return (bau === 'schlank') ? m[0][0] : m[m.length - 1][0];
  }
  function girthBucket(cm) { if (cm == null) return 'none'; if (cm < 38) return 'bu_lt38'; if (cm < 49.1) return 'bu_38_49'; if (cm < 55.5) return 'bu_49_55'; if (cm <= 62.7) return 'bu_55_627'; if (cm <= 70.1) return 'bu_628_70'; return 'bu_70plus'; }
  function weightBucket(kg) { if (kg == null) return 'w_unsure'; return kg < 4 ? 'w_lt4' : (kg < 6.5 ? 'w_4_65' : (kg < 9 ? 'w_65_9' : (kg < 11.5 ? 'w_9_115' : (kg <= 18 ? 'w_115_18' : (kg <= 28 ? 'w_18_28' : 'w_28plus'))))); }

  function dl(ev, d) { try { window.dataLayer = window.dataLayer || []; var o = { event: ev }, k; for (k in FUNNEL) o[k] = FUNNEL[k]; if (d) for (k in d) o[k] = d[k]; window.dataLayer.push(o); } catch (e) {} }
  function buzz() { if (RM) return; try { if (navigator.vibrate) navigator.vibrate(8); } catch (e) {} }
  function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }
  function clear(n) { while (n && n.firstChild) n.removeChild(n.firstChild); }
  function fmtKg(kg) { return String(kg).replace('.', ','); }
  function productName(h) { return h === 'air-mesh-pro' ? 'Air Mesh Pro' : (h === 'comfort-pro' ? 'Comfort Pro' : 'Comfort Basic'); }

  function initRoot(root) {
    if (root.getAttribute('data-init')) return;
    root.setAttribute('data-init', '1');
    var hero = root.querySelector('[data-hero]'), quiz = root.querySelector('[data-quiz]'), res = root.querySelector('[data-res]');
    var foot = root.querySelector('[data-foot]'), footModels = root.querySelector('[data-foot-models]');
    var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
    var bar = root.querySelector('[data-bar]'), pcount = root.querySelector('[data-pcount]');
    var pstrip = root.querySelector('[data-profilstrip]'), pconf = root.querySelector('[data-confmeter]');
    var steps = {}; [].slice.call(root.querySelectorAll('[data-step]')).forEach(function (e) { steps[e.getAttribute('data-step')] = e; });
    if (!quiz || !res || !panels.length) return;
    var gIn = root.querySelector('[data-girth]'), gErr = root.querySelector('[data-gerr]');
    var sgIn = root.querySelector('[data-s2girth]'), sgErr = root.querySelector('[data-s2gerr]');
    var gErrDefault = gErr ? gErr.textContent : '';
    var sgErrDefault = sgErr ? sgErr.textContent : '';

    var S, busy = false, hist = [], s2queue = [], s2idx = 0, s2Final = false, lastPhys = null, stepShownAt = 0, resultObserver = null, girthHintDefault = null;
    function fresh() { return { weight: null, wLabel: null, problems: [], context: null, bau: null, girth: null, s2: {}, sev: {}, swatch: 0, orthoDiag: false }; }
    function dwellBucket() { if (!stepShownAt) return 'lt3s'; var s = (Date.now() - stepShownAt) / 1000; return s < 3 ? 'lt3s' : (s < 10 ? '3_10s' : (s < 30 ? '10_30s' : '30s_plus')); }
    function isOor() { return (S.girth != null) && (S.girth < SIZES[0][3] || S.girth > SIZES[SIZES.length - 1][4]); }

    // ---------- PROFILE (Maschine 2, sichtbar) ----------
    function computeNeeds() {
      var n = { FIT: 0, ESCAPE: 0, PULL: 0, COMFORT: 0, ORTHO: 0 }, p = S.problems;
      if (p.indexOf('scheuern') >= 0) n.FIT += 3;
      if (p.indexOf('passt') >= 0) n.FIT += 2;
      if (p.indexOf('escape') >= 0) { if (S.s2.escape === 'zu_locker') n.FIT += 3; else n.ESCAPE += 3; }
      if (p.indexOf('ziehen') >= 0) n.PULL += 3;
      if (p.indexOf('anlege') >= 0) n.COMFORT += 3;
      if (p.indexOf('ortho') >= 0) n.ORTHO += 3;
      if (S.context === 'stadt') n.FIT += 1;
      if (S.context === 'outdoor') n.ESCAPE += 1;
      if (S.context === 'sport') n.PULL += 2;
      if (S.context === 'senior') { n.ORTHO += 2; n.COMFORT += 1; }
      if (S.s2.scheuern) n.FIT += 2;
      if (S.s2.ziehen === 'zieht_zur_seite') n.FIT += 2; else if (S.s2.ziehen) n.PULL += 2;
      if (S.s2.escape === 'zu_locker') n.FIT += 2; else if (S.s2.escape) n.ESCAPE += 2;
      if (S.s2.anlege) n.COMFORT += 2;
      if (S.s2.ortho) n.ORTHO += 1;
      return n;
    }
    // Nur Problem-Signale (Q2-Cards + S2-Schärfung), OHNE Q3-Kontext: einzige Quelle für den Familien-Kipp in der Überlappung
    function problemNeeds() {
      var n = { FIT: 0, ESCAPE: 0, PULL: 0, COMFORT: 0, ORTHO: 0 }, p = S.problems;
      if (p.indexOf('scheuern') >= 0) n.FIT += 3;
      if (p.indexOf('passt') >= 0) n.FIT += 2;
      if (p.indexOf('escape') >= 0) { if (S.s2.escape === 'zu_locker') n.FIT += 3; else n.ESCAPE += 3; }
      if (p.indexOf('ziehen') >= 0) n.PULL += 3;
      if (p.indexOf('anlege') >= 0) n.COMFORT += 3;
      if (p.indexOf('ortho') >= 0) n.ORTHO += 3;
      if (S.s2.scheuern) n.FIT += 2;
      if (S.s2.ziehen === 'zieht_zur_seite') n.FIT += 2; else if (S.s2.ziehen) n.PULL += 2;
      if (S.s2.escape === 'zu_locker') n.FIT += 2; else if (S.s2.escape) n.ESCAPE += 2;
      if (S.s2.anlege) n.COMFORT += 2;
      if (S.s2.ortho) n.ORTHO += 1;
      return n;
    }
    var DIM_ORDER = ['FIT', 'ESCAPE', 'PULL', 'COMFORT', 'ORTHO'];
    function dominant(n) { var d = 'FIT', mx = -1; DIM_ORDER.forEach(function (k) { if (n[k] > mx) { mx = n[k]; d = k; } }); return (mx === 0) ? 'NONE' : d; }
    function secondary(n, dom) { var s = '', mx = 0; DIM_ORDER.forEach(function (k) { if (k !== dom && n[k] > mx) { mx = n[k]; s = k; } }); return s; }
    var PROBLEM_ORDER = ['scheuern', 'escape', 'ziehen', 'anlege', 'passt', 'ortho', 'keins'];
    function problemsCanonical() { return S.problems.slice().sort(function (a, b) { return PROBLEM_ORDER.indexOf(a) - PROBLEM_ORDER.indexOf(b); }).join('|'); }
    function koerperbauText() {
      var parts = [];
      if (S.wLabel) parts.push(S.wLabel);
      else if (S.weight != null) parts.push('etwa ' + fmtKg(S.weight) + ' kg');
      var bm = { schlank: 'schlank gebaut', normal: 'normal proportioniert', kraeftig: 'kräftig und breit', tief_schmal: 'tiefe, schmale Brust' };
      if (S.bau && bm[S.bau]) parts.push(bm[S.bau]);
      if (S.girth) parts.push(fmtKg(S.girth) + ' cm Brustumfang (gemessen)');
      else if (S.weight != null) { var fam = famFromWeight(S.weight); if (fam === 'overlap') parts.push('im Größen-Grenzbereich'); }
      return parts.join(', ');
    }
    function anatomieHinweis() {
      var h = [];
      if ((S.bau === 'schlank' || S.bau === 'tief_schmal') && S.problems.indexOf('escape') >= 0) h.push('Schmaler Brustkorb: neigt anatomisch zum Rückwärts-Rausschlüpfen.');
      if (S.bau === 'tief_schmal' && S.problems.indexOf('scheuern') >= 0) h.push('Tiefe Brust: erhöhtes Scheuer-Risiko an der falschen Gurtlinie.');
      if (S.bau === 'kraeftig' && (S.problems.indexOf('ziehen') >= 0 || S.context === 'sport')) h.push('Kräftiger Bau plus Zug: braucht eine stabile Konstruktion.');
      return h;
    }
    var KONTEXT_LABEL = { stadt: 'Stadt und Reizdichte', outdoor: 'Outdoor und Sicherheit', sport: 'Sport und aktiv', senior: 'Senior und ruhig', welpe: 'Welpe im Wachstum' };
    function intensityWord(v) { return v >= 4 ? 'stark' : (v >= 2 ? 'deutlich' : (v >= 1 ? 'leicht' : '')); }
    var DIM_LABEL = { FIT: 'Passform', ESCAPE: 'Sicherheit', PULL: 'Zug-Kontrolle', COMFORT: 'Komfort', ORTHO: 'Gelenkschonung' };
    var BAR_LABEL = { FIT: 'Passform', ESCAPE: 'Sicherheit', PULL: 'Zug-Kontrolle', COMFORT: 'Komfort', ORTHO: 'Gelenke' };

    function updateStrip(pop) {
      if (!pstrip) return;
      var desired = [];
      var kb = koerperbauText(); if (kb) desired.push({ text: kb, lead: false });
      if (S.context && KONTEXT_LABEL[S.context]) desired.push({ text: KONTEXT_LABEL[S.context], lead: false });
      var n = computeNeeds(); var dom = dominant(n);
      if (dom !== 'NONE') desired.push({ text: 'Hebel: ' + DIM_LABEL[dom], lead: true });
      var kids = [].slice.call(pstrip.children); var keep = 0;
      while (keep < kids.length && keep < desired.length && kids[keep].textContent === desired[keep].text && kids[keep].classList.contains('dsf__ptag--lead') === desired[keep].lead) keep++;
      var retained = kids.slice(0, keep);
      var firstRects = (!RM && retained.length) ? retained.map(function (e) { return e.getBoundingClientRect(); }) : null;
      for (var r = kids.length - 1; r >= keep; r--) pstrip.removeChild(kids[r]);
      for (var ai = keep; ai < desired.length; ai++) {
        (function (dsc) {
          var sp = el('span', 'dsf__ptag dsf__ptag--new' + (dsc.lead ? ' dsf__ptag--lead' : ''));
          sp.textContent = dsc.text;
          if (dsc.lead) sp.appendChild(el('span', 'dsf__sheen'));
          pstrip.appendChild(sp);
          setTimeout(function () { sp.classList.remove('dsf__ptag--new'); }, 900);
        })(desired[ai]);
      }
      if (firstRects) {
        retained.forEach(function (e, i) {
          var a = e.getBoundingClientRect();
          var dx = firstRects[i].left - a.left, dy = firstRects[i].top - a.top;
          if (dx || dy) {
            e.style.transition = 'none'; e.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
            requestAnimationFrame(function () { e.style.transition = 'transform .55s cubic-bezier(.34,1.12,.42,1)'; e.style.transform = ''; });
          }
        });
      }
      if (pconf) {
        var oorNow = isOor();
        var lvl = S.girth ? (oorNow ? 60 : 100) : (S.weight != null ? (famFromWeight(S.weight) === 'overlap' ? 60 : 78) : 40);
        var fillEl = pconf.querySelector('[data-conffill]'); if (fillEl) fillEl.style.width = lvl + '%';
        var txt = pconf.querySelector('[data-conftext]');
        if (txt) {
          txt.textContent = S.girth ? (oorNow ? 'Passgenauigkeit: außerhalb der Größentabelle' : 'Passgenauigkeit: sehr hoch') : (S.weight != null ? 'Passgenauigkeit: gut, mit Messung exakt' : 'Passgenauigkeit: erst grob');
          if (S.girth && pop === true) { txt.classList.remove('dsf__pop'); void txt.offsetWidth; txt.classList.add('dsf__pop'); }
          else if (!S.girth) txt.classList.remove('dsf__pop');
        }
      }
    }

    // ---------- PHYSIK-GATE (Maschine 1) ----------
    function needsPro() {
      if (S.problems.indexOf('ziehen') >= 0) return true;
      if (S.problems.indexOf('escape') >= 0 && S.s2.escape !== 'zu_locker') return true;
      if (S.orthoDiag || S.problems.indexOf('ortho') >= 0) return true;
      if (S.context === 'sport') return true;
      if (S.problems.indexOf('passt') >= 0) return true;
      if (S.problems.indexOf('scheuern') >= 0) return S.s2.scheuern !== 'in_achseln';
      return false;
    }
    function resolvePhysical() {
      var fam, source;
      if (S.girth) { fam = famFromChest(S.girth); source = 'chest'; }
      else if (S.weight != null) { fam = famFromWeight(S.weight); source = 'weight'; }
      else { fam = 'amp'; source = 'fallback_amp'; }
      if (fam === 'overlap') {
        var pn = problemNeeds();
        if (pn.ESCAPE > 0 || pn.PULL >= 2 || pn.ORTHO > 0) { fam = 'comfort'; source = 'overlap_needs'; }
        else if (S.bau === 'kraeftig' || S.bau === 'tief_schmal') { fam = 'comfort'; source = 'overlap_bau'; }
        else { fam = 'amp'; source = 'overlap_default'; }
      }
      var product, alternative;
      if (fam === 'amp') { product = 'air-mesh-pro'; alternative = null; }
      else {
        if (needsPro()) { product = 'comfort-pro'; alternative = 'comfort-basic'; }
        else if (!S.problems.length || S.problems.indexOf('keins') >= 0) { product = 'comfort-pro'; alternative = 'comfort-basic'; }
        else { product = 'comfort-basic'; alternative = 'comfort-pro'; }
      }
      var size = S.girth ? chestToSize(S.girth) : roughSize(S.weight, S.bau || 'normal'); if (!size) size = 'M';
      if (!S.girth && S.s2.size && size) { var si = sizeIdx(size); if (S.s2.size === 'eher_streng' && SIZES[si - 1]) size = SIZES[si - 1][0]; else if (S.s2.size === 'hat_luft' && SIZES[si + 1]) size = SIZES[si + 1][0]; }
      // Größe auf verfügbare Produktpalette klemmen: Air Mesh Pro 3XS..XL (idx 0..6), Comfort XL..4XL (idx 6..9)
      var sc = sizeIdx(size); if (sc < 0) sc = 4; if (product === 'air-mesh-pro') { if (sc > 6) sc = 6; } else { if (sc < 6) sc = 6; } size = SIZES[sc][0];
      var oor = isOor();
      var conf;
      if (S.girth) conf = oor ? 'niedrig' : 'hoch';
      else if (S.weight != null) { var fw = famFromWeight(S.weight); conf = (fw === 'overlap' && (S.bau === 'normal' || !S.bau)) ? 'niedrig' : 'mittel'; if (S.problems.indexOf('passt') >= 0 && !S.s2.size) conf = 'niedrig'; }
      else conf = 'niedrig';
      if (conf === 'mittel' && S.s2.size === 'unsicher') conf = 'niedrig';
      return { family: (product === 'air-mesh-pro' ? 'amp' : 'comfort'), product: product, alternative: alternative, size: size, confidence: conf, source: source, oor: oor };
    }
    function honestGaps(fam) {
      return {
        klein_escape: fam === 'amp' && S.problems.indexOf('escape') >= 0 && S.s2.escape !== 'zu_locker',
        klein_zug: fam === 'amp' && S.problems.indexOf('ziehen') >= 0,
        gross_anlege: fam === 'comfort' && S.problems.indexOf('anlege') >= 0
      };
    }

    // ---------- TYP-LABEL ----------
    function typLabel(dom) {
      var c = S.context;
      if (dom === 'FIT') return c === 'stadt' ? 'Der empfindliche Stadt-Begleiter' : 'Passform steht bei euch im Vordergrund';
      if (dom === 'ESCAPE') return 'Bei euch hat Sicherheit Vorrang';
      if (dom === 'PULL') return c === 'sport' ? 'Ein aktives, kraftvolles Gespann' : 'Ihr seid viel in Bewegung';
      if (dom === 'COMFORT') return c === 'senior' ? 'Ruhige, eingespielte Runden' : 'Behutsam, in eurem Tempo';
      if (dom === 'ORTHO') return 'Gelenke und Langzeit im Blick';
      return c === 'welpe' ? 'Ihr fangt gerade erst an, wir legen das Fundament' : 'Du planst vorausschauend';
    }

    // ---------- MECHANISMUS (Befund, liest S2-Antworten + dominanten Hebel) ----------
    function mechFor(key, fam) {
      var sevEsc = (S.sev.escape >= 3) ? ' Weil er schon mehrfach entkommen ist, stellen wir Sicherheit über alles andere.' : '';
      if (key === 'escape') {
        if (S.s2.escape === 'zu_locker') return 'Schlüpft dein Hund nur heraus, wenn das Geschirr zu locker sitzt, ist es kein Ausbruchs-, sondern ein Passform-Thema. Miss den Brustumfang und stell es mit der Zwei-Finger-Regel ein, dann sitzt es sicher.';
        if (fam === 'amp') return 'Bei kleinen, schmal gebauten Hunden ist der Brustkorb hinter den Vorderbeinen enger als der Halsausschnitt, deshalb gehen sie rückwärts heraus. Ein leichtes Step-in löst das nicht vollständig, ehrlich gesagt. Wir setzen auf engen Sitz und eine zusätzliche Sicherung.' + sevEsc;
        return 'Schmal gebaute oder schreckhafte Hunde ziehen sich aus Zwei-Gurt-Geschirren rückwärts heraus. Die Lösung ist mechanisch: eine Über-Kopf-Konstruktion mit verstellbarem Hals und Brust, die nicht zurückrutschen kann.' + sevEsc;
      }
      if (key === 'scheuern') {
        var loc = S.s2.scheuern;
        if (loc === 'mehrere_wund') return 'Reibt es an mehreren Stellen und ist die Haut schon wund, stimmen Größe und Schnitt grundsätzlich nicht. Erst exakt messen, dann neu anlegen, und der gereizten Haut Zeit geben, bevor das neue Geschirr dauerhaft drauf sitzt.';
        if (loc === 'am_hals') return 'Druck am Hals heißt meist zu eng oder falsche Größe. Maßgeblich ist der gemessene Brustumfang, nicht das Gewicht, genau hier setzen wir an.';
        if (fam === 'amp') {
          if (loc === 'an_schulter') return 'Reibt es vorne an den Schulterblättern, läuft der Gurt quer über das Schultergelenk und stört die Bewegung. Ein Y-Schnitt führt den Gurt vor der Brust vorbei und lässt die Schulter frei.';
          return 'Scheuern in den Achseln entsteht, wenn der Gurt zu weit vorn oder zu tief sitzt. Der anatomische Y-Schnitt hält die Achseln frei, und die richtige Größe macht den Unterschied.';
        }
        if (loc === 'an_schulter') return 'Reibt es vorne an den Schulterblättern, läuft der Gurt quer über das Schultergelenk. Die Lösung ist die Gurtlinie: Hals und Brust getrennt einstellen, bis die Schulter frei läuft.';
        return 'Scheuern in den Achseln entsteht, wenn der Brustgurt zu weit vorn sitzt. Mit dem beidseitig verstellbaren Brustgurt schiebst du die Gurtlinie aus der Achsel, die richtige Größe macht den Rest.';
      }
      if (key === 'ziehen') {
        if (S.s2.ziehen === 'zieht_zur_seite') return 'Zieht dein Hund zur Seite und verrutscht dabei das Geschirr, ist die Ursache die Passform, nicht der Zug. Maßgeblich ist der gemessene Brustumfang, dann sitzt es stabil und du kannst am Training arbeiten.';
        if (S.s2.ziehen === 'angewoehnt') return 'Hat sich das Ziehen über Jahre eingeschliffen, ändert ein Geschirr das nicht. Es macht das Gehen angenehmer und schützt den Hals, die Gewohnheit löst ihr über Training in kleinen Schritten.' + (fam === 'comfort' ? ' Der Brustring am Comfort Pro hilft dir dabei, sanft umzulenken.' : '');
        if (fam === 'amp') return 'Kleine Hunde ziehen meist aus Erregung, nicht aus Sturheit. Ein Geschirr löst das Ziehen nicht, es macht das Gehen nur bequemer und nimmt Druck vom Hals. Leinenführigkeit kommt aus dem Training.';
        return 'Ziehen ist meist Reizdichte, nicht Charakter. Ein Geschirr löst das Ziehen nicht, aber der Brustring am Comfort Pro hilft dir, sanft umzulenken und das Training zu unterstützen.';
      }
      if (key === 'anlege') {
        if (fam === 'amp') {
          if (S.s2.anlege === 'nur_ueber_kopf') return 'Wenn nur das Über-den-Kopf-Ziehen stresst, ist ein Step-in die direkte Lösung: dein Hund steigt einfach hinein, nichts muss über den Kopf.';
          return 'Anlege-Stress ist oft eine Schmerz-Verknüpfung aus früherem Scheuern oder dem Ziehen über den Kopf. Ein Step-in, in das dein Hund einfach hineinsteigt, nimmt genau diesen Auslöser heraus.';
        }
        return 'Anlege-Stress sitzt meist in der Gewöhnung, nicht am Geschirr. Für große Hunde gibt es kein Step-in, hier helfen kleine, positive Schritte beim Anlegen mehr als ein anderes Produkt.';
      }
      if (key === 'passt') return 'Dass nichts richtig sitzt, liegt fast nie am Hund. Meist passt der Hals, aber die Brust nicht. Genau das lösen wir über den gemessenen Brustumfang und feiner abgestufte Größen.';
      if (key === 'ortho') return 'Bei Dauergebrauch verändert ein schlecht sitzendes Geschirr die Belastung. Ein Y-Schnitt, der die Schulter frei lässt, verteilt den Zug gleichmäßiger. Ein Geschirr ist dabei kein Therapieersatz, bei einer Diagnose sprich die Wahl zusätzlich mit deiner Tierärztin ab.';
      return null;
    }
    function mechanismusTexts(fam, dom) {
      var p = S.problems;
      var byDom = { ESCAPE: 'escape', PULL: 'ziehen', COMFORT: 'anlege', ORTHO: 'ortho', FIT: (p.indexOf('scheuern') >= 0 ? 'scheuern' : 'passt') };
      var primary = byDom[dom];
      if (!(primary && (p.indexOf(primary) >= 0 || (primary === 'ortho' && S.orthoDiag)))) {
        primary = null;
        var chain = ['escape', 'scheuern', 'ziehen', 'anlege', 'passt', 'ortho'];
        for (var i = 0; i < chain.length; i++) if (p.indexOf(chain[i]) >= 0) { primary = chain[i]; break; }
      }
      var out = [];
      if (primary) out.push(mechFor(primary, fam));
      else if (S.context === 'welpe') out.push('Im Wachstum zählt der heutige Brustumfang, nicht die Endgröße. Wir gehen nach Körperbau und Maß von heute, nachjustieren kannst du über den Verstellbereich.');
      else out.push('Du willst es von Anfang an richtig machen. Wir gehen nach Körperbau und Brustumfang, damit das Geschirr sofort passt.');
      if (primary) {
        var pool = ['escape', 'scheuern', 'ziehen', 'anlege', 'passt', 'ortho'];
        for (var j = 0; j < p.length; j++) {
          if (p[j] !== primary && p[j] !== 'keins' && pool.indexOf(p[j]) >= 0) { var t2 = mechFor(p[j], fam); if (t2) out.push(t2); break; }
        }
      }
      return out.slice(0, 2);
    }

    // ---------- FITTING-PLAN ----------
    function fittingTips() {
      var t = [], p = S.problems;
      t.push({ b: 'Zwei-Finger-Test', t: ' wenn das Geschirr da ist: zwei flache Finger passen unter den Gurt, lassen sich aber nicht verdrehen. Dann sitzt es richtig.' });
      if (p.indexOf('passt') >= 0 || !S.girth) t.push({ b: 'Brustumfang messen', t: ' im Stehen vom Widerrist um die breiteste Stelle des Brustkorbs, direkt hinter den Vorderbeinen, weiches Maßband, anliegend, ohne Zugabe. Das ist der sicherste Weg zur richtigen Größe.' });
      if (p.indexOf('anlege') >= 0) t.push({ b: 'Gewöhnung in Schritten', t: ' Geschirr mit Leckerli verknüpfen, erst anlegen ohne Spaziergang, in kleinen positiven Etappen.' });
      if (p.indexOf('escape') >= 0) t.push({ b: 'Doppelt sichern', t: ' bei Ausbruchskünstlern die Leine zusätzlich am Halsband sichern und das Geschirr eng einstellen. Kein Geschirr ist hundertprozentig ausbruchsicher.' });
      if (p.indexOf('ortho') >= 0) t.push({ b: 'Typen wechseln', t: ' bei Dauergebrauch verschiedene gut sitzende Geschirre abwechseln und bei einer Diagnose mit deiner Tierärztin abstimmen.' });
      if (S.context === 'welpe') t.push({ b: 'Noch im Wachstum', t: ' miss alle paar Wochen den Brustumfang nach. Die Größe stimmt für heute, dein Hund wächst noch hinein und heraus.' });
      if (S.context === 'sport') t.push({ b: 'Aktiv unterwegs', t: ' den Haltegriff zum schnellen Sichern nutzen und nach intensiven Einheiten den Sitz nachjustieren.' });
      t.push({ b: 'Luftig und sauber', t: ' bei dichtem Fell oder im Sommer auf gute Belüftung achten und das Geschirr regelmäßig waschen, das verhindert Scheuern durch Schmutz.' });
      if (S.sev.escape >= 3) { for (var i = 0; i < t.length; i++) { if (t[i].b === 'Doppelt sichern') { var d = t.splice(i, 1)[0]; t.unshift(d); break; } } }
      return t.slice(0, 4);
    }

    var FEAT = {
      'air-mesh-pro': [
        { dim: 'FIT', b: 'Anatomischer Y-Schnitt', tGeneric: ': hält Schulter und Achseln frei, der Gurt läuft vor der Brust statt quer über das Gelenk.', tProblem: ': hält Schulter und Achseln frei, genau die Stellen, die du als Problem beschrieben hast.' },
        { dim: 'COMFORT', b: 'Step-in zum Hineinsteigen', tGeneric: ': dein Hund steigt einfach hinein, nichts über den Kopf.', tProblem: ': nichts über den Kopf, das nimmt genau den Anlege-Stress heraus, den du beschrieben hast.' },
        { dim: 'ANY', b: 'Federleicht, Verschluss mit einer Hand', tGeneric: ', gekreuzte Bänder verteilen die Last gleichmäßig.', tProblem: ', gekreuzte Bänder verteilen die Last gleichmäßig.' }
      ],
      'comfort-pro': [
        { dim: 'ESCAPE', b: 'Über-Kopf-Konstruktion, an Hals und Brust verstellbar', tGeneric: ': sitzt sicher und ist schwer abzustreifen.', tProblem: ': sitzt sicher und ist schwer abzustreifen, genau gegen das Herausschlüpfen, das du beschrieben hast.' },
        { dim: 'PULL', b: 'Brustring zum sanften Umlenken', tGeneric: ': lenkt sanft um, praktisch bei aktiven Spaziergängen.', tProblem: ': unterstützt das Training, weil dein Hund zieht, löst das Ziehen aber nicht allein.' },
        { dim: 'ANY', b: 'Gepolsterter Haltegriff und Reflektoren', tGeneric: ' für volle Kontrolle und Sichtbarkeit.', tProblem: ' für volle Kontrolle und Sichtbarkeit.' }
      ],
      'comfort-basic': [
        { dim: 'COMFORT', b: 'Einhändig bedienbare Schnalle', tGeneric: ': schnell angelegt, ohne Stress am großen Hund.', tProblem: ': schnell angelegt, ohne Stress am großen Hund.' },
        { dim: 'FIT', b: 'Beidseitig verstellbarer Brustgurt', tGeneric: ': sitzt sauber am Körperbau, weite Halszone.', tProblem: ': lässt sich genau an der Achsel-Linie einstellen, da, wo es bei deinem Hund reibt.' },
        { dim: 'ANY', b: 'Leichtes Über-Kopf-Geschirr, faires Preis-Leistungs-Verhältnis', tGeneric: ' für entspannte Hunde.', tProblem: ' für entspannte Hunde.' }
      ]
    };
    function featuresFor(product, dom) {
      var list = FEAT[product].slice();
      var rel = { FIT: (S.problems.indexOf('scheuern') >= 0 || S.problems.indexOf('passt') >= 0), ESCAPE: (S.problems.indexOf('escape') >= 0 && S.s2.escape !== 'zu_locker'), PULL: S.problems.indexOf('ziehen') >= 0, COMFORT: S.problems.indexOf('anlege') >= 0, ORTHO: S.problems.indexOf('ortho') >= 0 };
      function score(f) { var s = 0; if (rel[f.dim]) s += 2; if (f.dim === dom) s += 1; if (f.dim === 'ANY') s -= 1; return s; }
      list.sort(function (a, b) { return score(b) - score(a); });
      return list.map(function (f) { return { b: f.b, t: rel[f.dim] ? f.tProblem : f.tGeneric }; });
    }

    // ---------- FLOW ----------
    var CORE = ['weight', 'problem', 'context', 'bau', 'girth'];
    function estTotal() {
      if (s2Final) return 5 + s2queue.length;
      var c = 0; ['escape', 'ziehen', 'scheuern', 'anlege', 'ortho'].forEach(function (k) { if (S.problems.indexOf(k) >= 0) c++; });
      return 5 + Math.min(3, c);
    }
    function setBar(pct, label) { if (bar) bar.style.width = Math.max(0, Math.min(100, pct)) + '%'; if (pcount && label != null) pcount.textContent = label; }
    function coreLabel(name) { var i = CORE.indexOf(name) + 1, tot = estTotal(); setBar((i / tot) * 96, 'Schritt ' + i + ' von ' + tot); }
    function focusHead(node) { var h = node && node.querySelector('.dsf__q'); if (h) { try { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } catch (e) {} } }
    function scrollTop() {
      var elem = (res && !res.hidden) ? res : ((quiz && !quiz.hidden) ? quiz : root);
      var lastY = null;
      function calcY() { return Math.max(0, elem.getBoundingClientRect().top + window.pageYOffset - 84); }
      function go() { try { lastY = calcY(); window.scrollTo({ top: lastY, behavior: RM ? 'auto' : 'smooth' }); } catch (e) {} }
      requestAnimationFrame(function () { requestAnimationFrame(go); });
      setTimeout(function () { try { var y2 = calcY(); if (lastY == null || Math.abs(y2 - lastY) > 8) { lastY = y2; window.scrollTo({ top: y2, behavior: RM ? 'auto' : 'smooth' }); } } catch (e) {} }, 250);
    }
    function syncGirthMode() {
      var hint = root.querySelector('[data-girth-hint]'), gsBtn = root.querySelector('[data-girth-skip]');
      if (hint && girthHintDefault == null) girthHintDefault = hint.textContent;
      if (S.weight == null) {
        if (gsBtn) gsBtn.hidden = true;
        if (hint) hint.textContent = 'Ohne Gewicht ist der Brustumfang unsere Grundlage für die richtige Größe. Die Anleitung unten dauert 15 Sekunden.';
      } else {
        if (gsBtn) gsBtn.hidden = false;
        if (hint && girthHintDefault != null) hint.textContent = girthHintDefault;
      }
    }
    function updateGirthCta() {
      var lblEl = root.querySelector('[data-girth-cta-label]'), hintEl = root.querySelector('[data-girth-cta-hint]');
      if (!lblEl) return;
      var raw = (gIn && gIn.value || '').trim().replace(',', '.');
      var n = parseFloat(raw); var g = (!isNaN(n) && n >= 15 && n <= 130) ? n : null;
      var q = buildQueue(g);
      lblEl.textContent = q.length ? 'Weiter' : 'Befund ansehen';
      if (hintEl) {
        if (q.length) { hintEl.hidden = false; hintEl.textContent = q.length === 1 ? 'Noch 1 kurze Frage, dann steht dein Befund.' : 'Noch ' + q.length + ' kurze Fragen, dann steht dein Befund.'; }
        else hintEl.hidden = true;
      }
    }
    function showStep(name) {
      Object.keys(steps).forEach(function (k) { if (steps[k]) steps[k].classList.toggle('on', k === name); });
      busy = false; stepShownAt = Date.now();
      if (name === 'girth') { syncGirthMode(); updateGirthCta(); }
      focusHead(steps[name]);
    }

    function start(ev) {
      var pos = (ev && ev.currentTarget && ev.currentTarget.getAttribute && ev.currentTarget.getAttribute('data-start-pos')) || 'restart';
      S = fresh(); busy = false; hist = ['weight']; s2queue = []; s2idx = 0; s2Final = false; lastPhys = null;
      if (hero) hero.hidden = true; if (foot) foot.hidden = true; res.hidden = true; quiz.hidden = false;
      [].slice.call(root.querySelectorAll('.dsf__opt.on')).forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-pressed', 'false'); });
      if (gIn) gIn.value = ''; if (sgIn) sgIn.value = '';
      if (pstrip) pstrip.parentNode.hidden = false;
      updateStrip(); coreLabel('weight'); showStep('weight');
      dl('finder_start', { cta_position: pos }); dl('finder_step_view', { step_id: 'weight' }); scrollTop();
    }
    function goCore(name) { hist.push(name); updateStrip(); coreLabel(name); showStep(name); dl('finder_step_view', { step_id: name }); scrollTop(); }
    function back() {
      if (busy) return;
      var from = hist[hist.length - 1]; hist.pop();
      var prev = hist.length ? hist[hist.length - 1] : null;
      dl('finder_step_back', { from_step: from || 'weight', to_step: prev || 'hero' });
      if (!prev) {
        if (hero) hero.hidden = false; if (foot) { foot.hidden = false; if (footModels) footModels.hidden = false; }
        quiz.hidden = true; if (pstrip) pstrip.parentNode.hidden = true; scrollTop(); return;
      }
      var tot = estTotal();
      if (CORE.indexOf(prev) >= 0) coreLabel(prev);
      else if (prev === 'reveal') setBar((5 / tot) * 96, 'Dein Zwischenbefund');
      else if (prev.indexOf('s2_') === 0) { s2idx = Math.max(0, s2idx - 1); setBar(((5 + s2idx + 1) / tot) * 96, 'Schritt ' + (5 + s2idx + 1) + ' von ' + tot); }
      showStep(prev); scrollTop();
    }

    // Q1 Gewicht: 8 Spannen-Cards (1 Tap, kein Tastatur-Gate). Repraesentativ-kg verifiziert:
    // 2.5->2XS amp | 5->S amp | 8->M amp | 10->L amp | 14->XL overlap | 20->2XL comfort | 30->4XL comfort (schlank 3XL)
    var WMAP = { w_lt4: [2.5, 'unter 4 kg'], w_4_65: [5, '4 bis 6,5 kg'], w_65_9: [8, '6,5 bis 9 kg'], w_9_115: [10, '9 bis 11,5 kg'], w_115_18: [14, '11,5 bis 18 kg'], w_18_28: [20, '18 bis 28 kg'], w_28plus: [30, 'über 28 kg'], w_unsure: [null, null] };
    var wStep = steps['weight'];
    if (wStep) wStep.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.dsf__opt[data-wbucket]') : null; if (!b || !wStep.contains(b) || busy) return;
      busy = true;
      [].slice.call(wStep.querySelectorAll('.dsf__opt')).forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); buzz();
      var wb = b.getAttribute('data-wbucket'), m = WMAP[wb] || [null, null];
      S.weight = m[0]; S.wLabel = m[1];
      dl('finder_question_answered', { question_id: 'q_gewicht', answer_value: wb, dwell_bucket: dwellBucket() });
      setTimeout(function () { goCore('problem'); }, 230);
    });

    var probStep = steps['problem'];
    if (probStep) probStep.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.dsf__opt[data-problem]') : null; if (!b || !probStep.contains(b)) return;
      var v = b.getAttribute('data-problem'), isOn = b.classList.contains('on');
      if (v === 'keins') { S.problems = ['keins']; [].slice.call(probStep.querySelectorAll('.dsf__opt')).forEach(function (o) { var on = (o === b); o.classList.toggle('on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); }); buzz(); return; }
      var kn = probStep.querySelector('.dsf__opt[data-problem="keins"]'); if (kn) { kn.classList.remove('on'); kn.setAttribute('aria-pressed', 'false'); }
      var ki = S.problems.indexOf('keins'); if (ki >= 0) S.problems.splice(ki, 1);
      if (isOn) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); var i = S.problems.indexOf(v); if (i >= 0) S.problems.splice(i, 1); }
      else { if (S.problems.length >= 3) { b.classList.add('shake'); setTimeout(function () { b.classList.remove('shake'); }, 400); return; } b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); S.problems.push(v); }
      buzz();
    });
    var pn = root.querySelector('[data-next-problem]');
    if (pn) pn.addEventListener('click', function () {
      if (busy) return; if (!S.problems.length) S.problems = ['keins'];
      dl('finder_question_answered', { question_id: 'q_problem', answer_value: problemsCanonical(), problem_count: S.problems.length, dwell_bucket: dwellBucket() });
      goCore('context');
    });

    var ctxStep = steps['context'];
    if (ctxStep) ctxStep.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.dsf__opt[data-context]') : null; if (!b || !ctxStep.contains(b) || busy) return;
      busy = true; [].slice.call(ctxStep.querySelectorAll('.dsf__opt')).forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); buzz(); S.context = b.getAttribute('data-context');
      dl('finder_question_answered', { question_id: 'q_kontext', answer_value: S.context, dwell_bucket: dwellBucket() }); setTimeout(function () { goCore('bau'); }, 230);
    });

    var bauStep = steps['bau'];
    if (bauStep) bauStep.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.dsf__opt[data-build]') : null; if (!b || !bauStep.contains(b) || busy) return;
      busy = true; [].slice.call(bauStep.querySelectorAll('.dsf__opt')).forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); buzz(); S.bau = b.getAttribute('data-build');
      dl('finder_question_answered', { question_id: 'q_bau', answer_value: S.bau, dwell_bucket: dwellBucket() }); setTimeout(function () { goCore('girth'); }, 230);
    });

    var gt = root.querySelector('[data-guide-toggle]'), guide = root.querySelector('[data-guide]');
    if (gt && guide) gt.addEventListener('click', function () { var o = guide.hasAttribute('hidden'); if (o) { guide.removeAttribute('hidden'); dl('finder_guide_open', {}); } else guide.setAttribute('hidden', ''); gt.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    function submitGirth() {
      if (busy) return; var raw = (gIn && gIn.value || '').trim().replace(',', '.');
      if (raw === '') {
        if (S.weight == null) { if (gErr) { gErr.textContent = 'Ohne Gewicht brauchen wir den Brustumfang, sonst können wir keine Größe nennen.'; gErr.hidden = false; } if (gIn) gIn.focus(); return; }
        afterStage1(); return;
      }
      var n = parseFloat(raw); if (isNaN(n) || n < 15 || n > 130) { if (gErr) { gErr.textContent = gErrDefault; gErr.hidden = false; } if (gIn) gIn.focus(); return; }
      if (gErr) gErr.hidden = true;
      S.girth = n; updateStrip(true);
      dl('finder_question_answered', { question_id: 'q_brustumfang', answer_value: girthBucket(n), dwell_bucket: dwellBucket() });
      var d = RM ? 0 : 750;
      if (!d) { afterStage1(); } else { busy = true; setTimeout(function () { busy = false; afterStage1(); }, d); }
    }
    var gn = root.querySelector('[data-next-girth]'); if (gn) gn.addEventListener('click', submitGirth);
    if (gIn) { gIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitGirth(); } }); gIn.addEventListener('input', function () { if (gErr) gErr.hidden = true; updateGirthCta(); }); }
    var gs = root.querySelector('[data-girth-skip]');
    if (gs) gs.addEventListener('click', function () {
      if (busy) return;
      if (S.weight == null) { if (gErr) { gErr.textContent = 'Ohne Gewicht brauchen wir den Brustumfang, sonst können wir keine Größe nennen.'; gErr.hidden = false; } if (gIn) gIn.focus(); return; }
      S.girth = null; dl('finder_question_answered', { question_id: 'q_brustumfang', answer_value: 'skip', dwell_bucket: dwellBucket() }); afterStage1();
    });

    function buildQueue(girthOverride) {
      var g = (arguments.length ? girthOverride : S.girth);
      var q = [], p = S.problems;
      if (p.indexOf('escape') >= 0) q.push('escape');
      if (p.indexOf('ziehen') >= 0) q.push('ziehen');
      if (p.indexOf('scheuern') >= 0) q.push('scheuern');
      var needSize = !g && (famFromWeight(S.weight) === 'overlap' || p.indexOf('passt') >= 0 || S.weight == null);
      if (needSize) q.push('size');
      if (p.indexOf('anlege') >= 0) q.push('anlege');
      if (p.indexOf('ortho') >= 0) q.push('ortho');
      return q.slice(0, 3).indexOf('ortho') < 0 && p.indexOf('ortho') >= 0 ? q.slice(0, 2).concat('ortho') : q.slice(0, 3);
    }
    function afterStage1() {
      busy = false; s2queue = buildQueue(); s2idx = 0; s2Final = true;
      var rev = revealText();
      if (rev) showReveal(rev); else nextS2();
    }
    function revealText() {
      var p = S.problems; if (!p.length || p.indexOf('keins') >= 0) return null;
      if (p.indexOf('escape') >= 0 && (S.bau === 'schlank' || S.bau === 'tief_schmal')) return 'Schmale, bewegliche Hunde kommen am leichtesten rückwärts raus. Das ist Anatomie, nicht Ungehorsam, gleich klären wir die Situation.';
      if (p.indexOf('scheuern') >= 0 && p.indexOf('anlege') >= 0) return 'Das hängt oft zusammen: scheuert ein Geschirr, verknüpft dein Hund das Anlegen mit Schmerz. Wir lösen zuerst die Passform.';
      if (p.indexOf('ziehen') >= 0 && S.context === 'stadt') return 'Ziehen ist in der Stadt selten Sturheit, meist Reizdichte. Gleich fragen wir, wann es am stärksten ist.';
      if (p.indexOf('escape') >= 0) return 'Ausbruch ist ein Sicherheitsthema, kein Erziehungsfehler. Wir schauen gleich genau hin, damit die Empfehlung hält.';
      if (p.indexOf('ziehen') >= 0) return 'Damit wir dir nichts Falsches versprechen: ein Geschirr löst Ziehen nicht, es macht es nur angenehmer. Gleich fragen wir, wie stark es ist.';
      if (p.indexOf('scheuern') >= 0) return 'Scheuern verrät über den Ort die Ursache. Gleich zeigst du uns, wo genau, dann wissen wir, woran es liegt.';
      return null;
    }
    function showReveal(text) {
      var rs = steps['reveal']; if (!rs) { nextS2(); return; }
      var n = computeNeeds(); var dom = dominant(n);
      var lbl = rs.querySelector('[data-reveal-typ]'); if (lbl) lbl.textContent = typLabel(dom);
      var pf = rs.querySelector('[data-reveal-profil]'); if (pf) { var kb = koerperbauText(); pf.textContent = kb ? (kb + (S.context && KONTEXT_LABEL[S.context] ? ', ' + KONTEXT_LABEL[S.context] : '')) : ''; }
      var t = rs.querySelector('[data-reveal-text]'); if (t) t.textContent = text;
      var more = rs.querySelector('[data-reveal-more]'); if (more) more.textContent = s2queue.length ? ('Noch ' + s2queue.length + (s2queue.length === 1 ? ' kurze Frage, dann hast du deinen Befund.' : ' kurze Fragen, dann hast du deinen Befund.')) : 'Wir haben alles. Hier ist dein Befund.';
      setBar((5 / estTotal()) * 96, 'Dein Zwischenbefund'); showStep('reveal'); hist.push('reveal'); dl('finder_step_view', { step_id: 'reveal' }); scrollTop();
    }
    var rn = root.querySelector('[data-reveal-next]'); if (rn) rn.addEventListener('click', function () { if (!busy) nextS2(); });

    function nextS2() {
      if (s2idx >= s2queue.length) { finish(); return; }
      var key = s2queue[s2idx], node = steps['s2_' + key];
      if (!node) { s2idx++; nextS2(); return; }
      if (key === 'size') {
        var h = node.querySelector('.dsf__q');
        if (h) {
          if (!S.girth && famFromWeight(S.weight) === 'overlap') h.textContent = 'Das Gewicht deines Hundes liegt genau zwischen zwei Größen.';
          else if (S.problems.indexOf('passt') >= 0) h.textContent = 'Damit es diesmal wirklich passt: Wie sitzt das aktuelle Geschirr?';
          else h.textContent = 'Für die exakte Größe fehlt uns noch ein Anhaltspunkt.';
        }
      }
      var tot = estTotal();
      setBar(((5 + s2idx + 1) / tot) * 96, 'Schritt ' + (5 + s2idx + 1) + ' von ' + tot);
      showStep('s2_' + key); hist.push('s2_' + key); dl('finder_step_view', { step_id: 's2_' + key }); scrollTop();
    }
    [].slice.call(root.querySelectorAll('[data-s2]')).forEach(function (node) {
      node.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.dsf__opt[data-s2val]') : null; if (!b || !node.contains(b) || busy) return;
        busy = true; var key = node.getAttribute('data-s2'), val = b.getAttribute('data-s2val');
        S.s2[key] = val;
        if (b.getAttribute('data-sev')) S.sev[key] = parseInt(b.getAttribute('data-sev'), 10);
        if (key === 'ortho') S.orthoDiag = (val === 'diagnostiziert' || val === 'verdacht');
        [].slice.call(node.querySelectorAll('.dsf__opt')).forEach(function (o) { o.classList.remove('on'); }); b.classList.add('on'); buzz();
        dl('finder_question_answered', { question_id: 's2_' + key, answer_value: val, dwell_bucket: dwellBucket() });
        setTimeout(function () { busy = false; s2idx++; nextS2(); }, 250);
      });
    });
    function submitS2Girth() {
      if (busy) return; var raw = (sgIn && sgIn.value || '').trim().replace(',', '.');
      if (raw === '') { if (sgErr) { sgErr.textContent = 'Gib einen Brustumfang ein oder wähle unten "Ohne Messen weiter".'; sgErr.hidden = false; } if (sgIn) sgIn.focus(); return; }
      var n = parseFloat(raw); if (isNaN(n) || n < 15 || n > 130) { if (sgErr) { sgErr.textContent = sgErrDefault; sgErr.hidden = false; } if (sgIn) sgIn.focus(); return; }
      if (sgErr) sgErr.hidden = true;
      S.girth = n; updateStrip(true);
      dl('finder_question_answered', { question_id: 's2_size', answer_value: girthBucket(n), dwell_bucket: dwellBucket() });
      var d = RM ? 0 : 750;
      if (!d) { s2idx++; nextS2(); } else { busy = true; setTimeout(function () { busy = false; s2idx++; nextS2(); }, d); }
    }
    var sgn = root.querySelector('[data-s2girth-next]'); if (sgn) sgn.addEventListener('click', submitS2Girth);
    if (sgIn) { sgIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitS2Girth(); } }); sgIn.addEventListener('input', function () { if (sgErr) sgErr.hidden = true; }); }
    var sgs = root.querySelector('[data-s2girth-skip]'); if (sgs) sgs.addEventListener('click', function () { if (busy) return; s2idx++; nextS2(); });
    [].slice.call(root.querySelectorAll('[data-finish-now]')).forEach(function (b) {
      b.addEventListener('click', function () {
        if (busy) return;
        dl('finder_reveal_skip', { from_step: hist[hist.length - 1] || '', s2_remaining: Math.max(0, s2queue.length - s2idx) });
        finish();
      });
    });

    // ---------- SWATCHES + Variant deeplink (+ Sticky-Sync + Crossfade) ----------
    function buildSwatches(panel, product, sizeLabel, conf) {
      var wrap = panel.querySelector('[data-swatches]'), img = panel.querySelector('[data-img]'), src = panel.querySelector('[data-colors]'), cta = panel.querySelector('[data-cta="pdp"]');
      if (!wrap || !img || !src) return false;
      var colors = []; try { colors = JSON.parse(src.textContent || '[]'); } catch (e) { colors = []; }
      function swapImage(c) {
        if (!c.img || img.getAttribute('src') === c.img) return;
        if (RM) { img.setAttribute('src', c.img); img.style.opacity = '1'; return; }
        var seq = String(parseInt(img.getAttribute('data-seq') || '0', 10) + 1);
        img.setAttribute('data-seq', seq);
        img.style.opacity = '0';
        var pre = new Image();
        var go = function () {
          if (img.getAttribute('data-seq') !== seq) return;
          img.setAttribute('src', c.img);
          requestAnimationFrame(function () { requestAnimationFrame(function () { img.style.opacity = '1'; }); });
        };
        pre.onload = go; pre.onerror = go; pre.src = c.img;
        if (pre.complete) setTimeout(go, 100);
      }
      // sizes enthaelt nur LIEFERBARE Varianten (VG-2609-SB8QF). Ist die Groesse in der
      // gewaehlten Farbe aus, springt die Auswahl auf die erste Farbe, die sie hat, und
      // sagt das. Hat keine Farbe sie, kein Tiefenlink und ein klarer Satz.
      function vidFor(c) { return c && c.sizes && (c.sizes[variantSizeCode(sizeLabel)] || c.sizes[sizeLabel]); }
      function note(text) {
        var n = panel.querySelector('[data-oos-note]');
        if (!text) { if (n) n.parentNode.removeChild(n); return; }
        if (!n) { n = el('p', 'dsf__oosnote'); n.setAttribute('data-oos-note', ''); n.style.cssText = 'font-size:13px;line-height:1.45;color:#6e6e73;text-align:center;margin:10px 0 0;'; wrap.parentNode.insertBefore(n, wrap.nextSibling); }
        n.textContent = text;
      }
      function markSwatches(on) {
        [].slice.call(wrap.querySelectorAll('.dsf__sw')).forEach(function (b) {
          var i = parseInt(b.getAttribute('data-i'), 10), c = colors[i];
          var aus = !vidFor(c);
          b.style.opacity = aus ? '0.35' : '';
          b.setAttribute('aria-label', 'Farbe ' + (c && c.name || (i + 1)) + (aus ? ', in dieser Größe ausverkauft' : ''));
          b.classList.toggle('on', i === on);
        });
      }
      function applyVariant(idx, vonHand) {
        var c = colors[idx]; if (!c) return false;
        var shown = sizeLabel;
        var msg = '';
        if (!vidFor(c) && conf !== 'niedrig') {
          var alt = -1;
          for (var j = 0; j < colors.length; j++) { if (colors[j] && colors[j].img && vidFor(colors[j])) { alt = j; break; } }
          if (alt < 0) msg = 'Größe ' + shown + ' ist gerade in keiner Farbe lieferbar.';
          else if (vonHand) msg = 'In ' + (c.name || 'dieser Farbe') + ' ist ' + shown + ' gerade ausverkauft. Lieferbar zum Beispiel in ' + colors[alt].name + '.';
          else { msg = 'In ' + (c.name || 'dieser Farbe') + ' ist ' + shown + ' gerade ausverkauft, darum zeigen wir ' + colors[alt].name + '.'; idx = alt; c = colors[alt]; S.swatch = alt; }
        }
        swapImage(c);
        markSwatches(idx);
        note(msg);
        var linked = false;
        if (cta) {
          var base = cta.getAttribute('data-base') || cta.getAttribute('href');
          var vid = vidFor(c);
          if (vid && conf !== 'niedrig') { cta.setAttribute('href', base + '?variant=' + vid); linked = true; }
          else cta.setAttribute('href', base);
          var sl = res.querySelector('[data-sticky-link]'); if (sl) sl.setAttribute('href', cta.getAttribute('href'));
        }
        return linked;
      }
      wrap._dsfApply = applyVariant;
      if (wrap.getAttribute('data-built')) return applyVariant(S.swatch || 0);
      clear(wrap);
      if (!colors.length) { wrap.setAttribute('data-built', '1'); return applyVariant(0); }
      colors.forEach(function (c, i) {
        if (!c || !c.img) return;
        var btn = el('button', 'dsf__sw'); btn.type = 'button'; btn.setAttribute('data-i', String(i)); btn.setAttribute('aria-label', 'Farbe ' + (c.name || (i + 1))); if (i === (S.swatch || 0)) btn.classList.add('on');
        var t = new Image(); t.src = c.thumb || c.img; t.alt = ''; t.loading = 'lazy'; t.decoding = 'async'; t.width = 44; t.height = 44; btn.appendChild(t);
        btn.addEventListener('click', function () { S.swatch = i; (wrap._dsfApply || applyVariant)(i, true); buzz(); dl('finder_swatch_click', { recommended_product: product, color: c.name || '' }); });
        wrap.appendChild(btn);
      });
      wrap.setAttribute('data-built', '1');
      return applyVariant(S.swatch || 0);
    }

    function noteList(node, items) { clear(node); items.forEach(function (it) { var li = el('li', 'dsf__ins'); var b = el('strong'); b.textContent = it.b; li.appendChild(b); li.appendChild(document.createTextNode(it.t)); node.appendChild(li); }); }

    // Shopify-Spam-Schutz (hCaptcha) laedt erst lazy bei Form-Interaktion. Da das Lead-Form
    // im Befund liegt, klickt der Nutzer oft sofort auf Senden, bevor hCaptcha bereit ist:
    // Shopifys Captcha-Handler verschluckt dann den ersten Submit ohne Token und ohne Feedback.
    // Fix: hCaptcha proaktiv vorladen, sobald der Befund (und damit das Form) sichtbar wird.
    // Synthetische focusin/mousedown-Events triggern Shopifys Loader OHNE echtes focus()
    // (kein Aufpoppen der Mobile-Tastatur). Token ist dann beim echten Senden bereit.
    var captchaWarmed = false;
    function warmCaptcha(leadEl) {
      if (captchaWarmed || !leadEl) return;
      var em = leadEl.querySelector('[name="contact[email]"]'); if (!em) return;
      captchaWarmed = true;
      setTimeout(function () {
        try {
          em.dispatchEvent(new Event('focusin', { bubbles: true }));
          em.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        } catch (e) {}
      }, 80);
    }

    // ---------- FINISH = Befund rendern ----------
    function finish(isRestore) {
      if (S.weight == null && S.girth == null) { showStep('girth'); return; }
      busy = false;
      var phys = resolvePhysical(); lastPhys = phys;
      var n = computeNeeds(); var dom = dominant(n); var sec = secondary(n, dom);
      var fam = phys.family, prod = phys.product, gaps = honestGaps(fam);
      var active = null; panels.forEach(function (p) { var on = p.getAttribute('data-panel') === prod; p.classList.toggle('on', on); if (on) active = p; });
      if (!active) { showStep('weight'); return; }
      ['.dsf__diag', '.dsf__panels', '.dsf__after'].forEach(function (sel) { var hn = res.querySelector(sel); if (hn) hn.hidden = false; });

      // Block 1: Diagnose-Kopf
      var diagTitle = res.querySelector('[data-diag-title]'); if (diagTitle) diagTitle.textContent = typLabel(dom);
      var badge = res.querySelector('[data-badge]');
      if (badge) badge.textContent = phys.oor ? 'Außerhalb unserer Größen' : (phys.confidence === 'hoch' ? 'Sicher' : (phys.confidence === 'mittel' ? 'Empfehlung' : 'Erst kurz messen'));
      var summary = res.querySelector('[data-diag-summary]');
      if (summary) { var kb = koerperbauText(); summary.textContent = 'Unser Befund: ' + (kb || 'dein Hund') + '. Der wichtigste Hebel ist ' + DIM_LABEL[dom === 'NONE' ? 'FIT' : dom] + '.'; }

      // Block 2: Profilkarte
      var pax = res.querySelector('[data-profil-axes]');
      if (pax) {
        clear(pax);
        var ax = function (label, val) { if (!val) return; var d = el('div', 'dsf__ax'); var k = el('span', 'dsf__ax-k'); k.textContent = label; var v = el('span', 'dsf__ax-v'); v.textContent = val; d.appendChild(k); d.appendChild(v); pax.appendChild(d); };
        ax('Körperbau', koerperbauText());
        var hints = anatomieHinweis(); if (hints.length) ax('Anatomie', hints[0]);
        if (S.context && KONTEXT_LABEL[S.context]) ax('Alltag', KONTEXT_LABEL[S.context]);
        if (dom !== 'NONE') ax('Hebel', DIM_LABEL[dom] + (sec ? ', dann ' + DIM_LABEL[sec] : ''));
      }
      var pbar = res.querySelector('[data-profil-bars]');
      if (pbar) {
        clear(pbar); var bi = 0;
        DIM_ORDER.forEach(function (k) {
          if (n[k] <= 0) return;
          var w = intensityWord(n[k]); var pct = n[k] >= 4 ? 100 : (n[k] >= 2 ? 66 : 33);
          var row = el('div', 'dsf__bar'); var lab = el('span', 'dsf__bar-l'); lab.textContent = BAR_LABEL[k];
          var tr = el('span', 'dsf__bar-t'); var fl = el('span', 'dsf__bar-f'); fl.style.width = pct + '%'; fl.style.animationDelay = (300 + bi * 90) + 'ms'; bi++;
          tr.appendChild(fl); var wv = el('span', 'dsf__bar-w'); wv.textContent = w;
          row.appendChild(lab); row.appendChild(tr); row.appendChild(wv); pbar.appendChild(row);
        });
      }

      // Block 3: Mechanismus (max 2 Absaetze)
      var mech = res.querySelector('[data-mechanismus]');
      if (mech) {
        var mts = mechanismusTexts(fam, dom);
        mech.textContent = mts[0] || '';
        var extras = mech.parentNode.querySelectorAll('[data-mech-extra]');
        for (var xi = extras.length - 1; xi >= 0; xi--) extras[xi].parentNode.removeChild(extras[xi]);
        if (mts[1]) { var p2 = el('p', 'dsf__mech-tx'); p2.setAttribute('data-mech-extra', '1'); p2.textContent = mts[1]; mech.parentNode.appendChild(p2); }
      }

      // Block 4: Empfehlung (Swatches/Deeplink VOR dem Size-Block, damit der Vorauswahl-Claim ehrlich ist)
      var linked = buildSwatches(active, prod, phys.size, phys.confidence);
      var ld = active.querySelector('[data-lead]');
      var who = S.girth ? ('Brustumfang ' + fmtKg(S.girth) + ' cm') : (S.wLabel ? S.wLabel : (S.weight != null ? (fmtKg(S.weight) + ' kg') : 'deinen Hund'));
      if (ld) {
        if (phys.oor) ld.textContent = (S.girth > SIZES[SIZES.length - 1][4]) ? ('Das ' + productName(prod) + ' in 4XL ist unser größtes Geschirr, deine Messung liegt darüber.') : ('Das ' + productName(prod) + ' in 3XS ist unser kleinstes Geschirr, deine Messung liegt darunter.');
        else ld.textContent = 'Für ' + who + ' und dein Profil ist das ' + productName(prod) + ' die passende Wahl.';
      }
      var feat = active.querySelector('[data-features]'); if (feat) noteList(feat, featuresFor(prod, dom));
      var sz = active.querySelector('[data-size]');
      if (sz) {
        var parts = [];
        if (phys.oor) {
          if (S.girth > SIZES[SIZES.length - 1][4]) parts = [{ b: 'Über unserem Größenspektrum', t: ': unsere größte Größe 4XL endet bei 92 cm Brustumfang. Bei ' + fmtKg(S.girth) + ' cm schließt das Geschirr nicht sicher. Schreib uns an kontakt@dogssupreme.de, wir schauen gemeinsam, was passt.' }];
          else parts = [{ b: 'Unter unserer kleinsten Größe', t: ': 3XS beginnt bei 26,7 cm Brustumfang. Miss bitte an der breitesten Stelle hinter den Vorderbeinen nach, bei einem Welpen wächst dein Hund bald hinein. Fragen? kontakt@dogssupreme.de.' }];
        } else {
          if (phys.confidence === 'hoch') parts = [{ b: 'Größe ' + phys.size, t: ', bei ' + fmtKg(S.girth) + ' cm Brustumfang.' + (linked ? ' Wir haben sie unten vorausgewählt.' : ' Wähle Größe ' + phys.size + ' auf der Produktseite.') }];
          else if (phys.confidence === 'mittel') parts = [{ b: 'Richtgröße ' + phys.size, t: '. Prüfe sie mit der Zwei-Finger-Regel, dann sitzt sie sicher.' }];
          else if (S.s2.size === 'unsicher') parts = [{ b: 'Wir tendieren zu Größe ' + phys.size, t: '. Du warst unsicher, genau dafür ist die Messung da: Brustumfang hinter den Vorderbeinen, dann ist die Größe eindeutig. Die Tabelle findest du auf der Produktseite.' }];
          else parts = [{ b: 'Wir tendieren zu Größe ' + phys.size, t: '. Miss kurz den Brustumfang, dann wird es exakt. Die Tabelle findest du auf der Produktseite.' }];
          if (S.context === 'welpe') parts.push({ b: 'Im Wachstum', t: ': wir empfehlen die Größe für heute, nicht für ausgewachsen. Ein zu großes Geschirr scheuert und lässt deinen Hund rausschlüpfen.' });
        }
        noteList(sz, parts);
      }

      // Block 5: Ehrlichkeit + Alternative
      var ehr = res.querySelector('[data-ehrlich]');
      if (ehr) {
        clear(ehr); var items = [];
        if (gaps.klein_escape) items.push({ b: 'Ehrlich zur Sicherheit', t: ': für kleine Ausbruchskünstler haben wir kein speziell ausbruchsicheres Geschirr. Stell das Air Mesh Pro sehr eng ein und sichere die Leine zusätzlich am Halsband.' });
        if (gaps.klein_zug) items.push({ b: 'Ehrlich zum Ziehen', t: ': ein Geschirr löst das Ziehen nicht. Leinenführigkeit kommt aus dem Training, das Air Mesh Pro macht das Gehen nur bequemer.' });
        if (gaps.gross_anlege) items.push({ b: 'Ehrlich zum Anlegen', t: ': für große Hunde gibt es kein Step-in. Mit kleinen, positiven Gewöhnungsschritten wird das Über-Kopf-Anlegen entspannter.' });
        if (S.problems.indexOf('ortho') >= 0) items.push({ b: 'Bei Gelenk-Themen', t: ': der Y-Schnitt entlastet die Schulter, ein Geschirr ist aber keine Therapie. Bei einer Diagnose stimme die Wahl mit deiner Tierärztin ab.' });
        if (S.context === 'welpe') items.push({ b: 'Ehrlich beim Welpen', t: ': wir empfehlen die Größe für jetzt, nicht zum Hineinwachsen. Ein zu großes Geschirr sitzt unsicher, beim nächsten Wachstumsschub misst du einfach neu.' });
        if (S.sev.scheuern >= 3) items.unshift({ b: 'Wunde Stellen zuerst', t: ': lass die gereizte Haut abheilen, bevor das neue Geschirr darüber liegt. Bei offenen oder nässenden Stellen zeig sie kurz deiner Tierärztin.' });
        if (phys.oor) items.unshift({ b: 'Ehrlich zur Größe', t: ': diese Messung liegt außerhalb unseres Sortiments von 26,7 bis 92 cm. Wir empfehlen dir nichts, was nicht sicher sitzt.' });
        if (!items.length) items.push({ b: 'Versprochen', t: ': passt etwas nicht perfekt, sagen wir es dir. Diese Empfehlung passt zu dem, was du beschrieben hast.' });
        noteList(ehr, items.slice(0, 2));
      }
      var altEl = res.querySelector('[data-alt]');
      if (altEl) {
        var aL = altEl.querySelector('a'), aPre = altEl.querySelector('[data-alt-pre]'), aPost = altEl.querySelector('[data-alt-post]');
        if (phys.alternative && !phys.oor) {
          altEl.hidden = false;
          if (aL) { aL.textContent = productName(phys.alternative); aL.setAttribute('href', '/products/' + phys.alternative); aL.setAttribute('data-cta', 'alternative'); aL.setAttribute('data-product', phys.alternative); }
          if (aPre) aPre.textContent = 'Beide passen deinem Hund. Auch möglich: ';
          if (aPost) aPost.textContent = (prod === 'comfort-pro') ? ', wenn dein Hund kaum zieht und du auf Brustring und Haltegriff verzichten kannst. Für dein Profil bleibt das Comfort Pro die sichere Wahl.' : ' mit Brustring und Haltegriff, falls ihr unterwegs doch mehr Kontrolle wollt.';
        } else altEl.hidden = true;
      }

      // Block 6: Fitting-Plan + Sticky-CTA
      var fit = res.querySelector('[data-fitting]'); if (fit) noteList(fit, fittingTips());
      var sticky = res.querySelector('[data-sticky]');
      var stx = res.querySelector('[data-sticky-tx]'); if (stx) stx.textContent = productName(prod) + ((phys.confidence === 'niedrig') ? '' : (', Größe ' + phys.size));
      var sl2 = res.querySelector('[data-sticky-link]'); if (sl2) sl2.setAttribute('data-product', prod);
      if (sticky) sticky.hidden = false;
      var lead0 = root.querySelector('[data-lead-form]'); if (lead0) { lead0.hidden = false; warmCaptcha(lead0); }

      if (hero) hero.hidden = true; quiz.hidden = true; if (pstrip) pstrip.parentNode.hidden = true;
      if (foot) foot.hidden = false; if (footModels) footModels.hidden = true;
      res.hidden = false; setBar(100, '');

      var maxSev = 0, sk; for (sk in S.sev) { if (S.sev[sk] > maxSev) maxSev = S.sev[sk]; }
      if (!isRestore) {
        dl('finder_recommendation_shown', {
          recommended_product: prod, alternative_product: phys.alternative || '',
          confidence: phys.confidence, size: phys.size,
          size_source: S.girth ? 'chest' : (S.weight != null ? (S.s2.size ? 'weight_s2adjust' : 'weight') : 'fallback'),
          family_source: phys.source, dominant: dom, secondary: sec || '',
          problems: problemsCanonical(), problem_count: S.problems.filter(function (pp) { return pp !== 'keins'; }).length,
          context: S.context || '', bau: S.bau || '',
          weight_bucket: weightBucket(S.weight), girth_bucket: girthBucket(S.girth),
          s2_escape: S.s2.escape || '', s2_ziehen: S.s2.ziehen || '', s2_scheuern: S.s2.scheuern || '',
          s2_anlege: S.s2.anlege || '', s2_ortho: S.s2.ortho || '', s2_size: S.s2.size || '',
          max_severity: maxSev || null,
          flags: [gaps.klein_escape ? 'klein_escape' : '', gaps.klein_zug ? 'klein_zug' : '', gaps.gross_anlege ? 'gross_anlege' : '', phys.oor ? 'girth_oor' : ''].filter(Boolean).join('|')
        });
        dl('finder_complete', { completed: true, outcome_product: prod });
      } else {
        dl('finder_restore', { recommended_product: prod, confidence: phys.confidence });
      }

      // Result-Scroll-Sichtbarkeit (einmal pro Sektion)
      if (resultObserver) { try { resultObserver.disconnect(); } catch (eo) {} resultObserver = null; }
      if (typeof IntersectionObserver !== 'undefined') {
        resultObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var nm = en.target.getAttribute('data-secview'); if (!nm) return;
            dl('finder_result_section_view', { section: nm });
            en.target.removeAttribute('data-secview');
            try { resultObserver.unobserve(en.target); } catch (eu) {}
          });
        }, { threshold: 0.4 });
        [[res.querySelector('.dsf__diag'), 'diag'], [active, 'product'], [res.querySelector('.dsf__after'), 'ehrlich'], [root.querySelector('[data-lead-form]'), 'lead']].forEach(function (pair) {
          if (pair[0]) { pair[0].setAttribute('data-secview', pair[1]); resultObserver.observe(pair[0]); }
        });
      }

      scrollTop(); try { res.focus({ preventScroll: true }); } catch (e) {}
    }

    res.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-cta]') : null; if (!a) return;
      dl('finder_result_cta_click', { cta_target: a.getAttribute('data-cta'), clicked_product: a.getAttribute('data-product') || null, recommended_product: lastPhys ? lastPhys.product : null, confidence: lastPhys ? lastPhys.confidence : null, size: lastPhys ? lastPhys.size : null });
    });

    // email native form (Double-Opt-In gated den Versand; Tags sind NIE Consent-Quelle)
    var lead = root.querySelector('[data-lead-form]'), lform = lead && lead.querySelector('form');
    function buildTags() {
      var t = ['finder-done'], phys = resolvePhysical(), n = computeNeeds(), dom = dominant(n), gaps = honestGaps(phys.family), k, c2 = 0;
      t.push('finder-empfehlung-' + phys.product);
      t.push('finder-groesse-' + (phys.family === 'comfort' ? 'gross' : 'klein'));
      for (k = 0; k < S.problems.length; k++) { if (S.problems[k] !== 'keins' && c2 < 3) { t.push('finder-problem-' + S.problems[k]); c2++; } }
      if (S.context) t.push('finder-kontext-' + S.context);
      t.push('finder-confidence-' + phys.confidence);
      t.push('finder-richtgroesse-' + String(phys.size).toLowerCase());
      if (dom !== 'NONE') t.push('finder-hebel-' + dom.toLowerCase());
      for (k in gaps) { if (gaps[k]) t.push('finder-gap-' + k); }
      t.push('finder-newsletter-pending');
      return t.join(',');
    }
    if (lform) {
      lform.addEventListener('submit', function (e) {
        var em = lform.querySelector('[data-email]'), cs = lform.querySelector('[data-consent]'), er = lform.querySelector('[data-lead-err]'), tg = lform.querySelector('[data-tags]');
        var email = em && em.value.trim(); if (!email) { e.preventDefault(); if (em) em.focus(); return; }
        if (cs && !cs.checked) { e.preventDefault(); if (er) er.hidden = false; cs.focus(); return; }
        if (er) er.hidden = true; if (tg) tg.value = buildTags();
        try { sessionStorage.setItem('dsf_restore', JSON.stringify({ w: S.weight, wl: S.wLabel, p: S.problems, c: S.context, b: S.bau, g: S.girth, s2: S.s2, od: S.orthoDiag })); } catch (x) {}
        var physE = resolvePhysical(), domE = dominant(computeNeeds());
        dl('finder_email_submit', { consent_state: 'granted', recommended_product: physE.product, confidence: physE.confidence, dominant: domE });
      });
      var cb = lform.querySelector('[data-consent]'); if (cb) cb.addEventListener('change', function () { var er = lform.querySelector('[data-lead-err]'); if (er) er.hidden = true; });
      // iPhone-Tastatur: Sticky-CTA waehrend E-Mail-Eingabe ausblenden
      lead.addEventListener('focusin', function () { var st = res.querySelector('[data-sticky]'); if (st) st.hidden = true; });
      lead.addEventListener('focusout', function () { var st = res.querySelector('[data-sticky]'); if (st && !res.hidden) st.hidden = false; });
    }
    var lskip = root.querySelector('[data-lead-skip]');
    if (lskip) lskip.addEventListener('click', function () { if (lead) lead.hidden = true; dl('finder_email_skip', { recommended_product: lastPhys ? lastPhys.product : '' }); });

    [].slice.call(root.querySelectorAll('[data-back]')).forEach(function (b) { b.addEventListener('click', back); });
    [].slice.call(root.querySelectorAll('[data-start]')).forEach(function (b) { b.addEventListener('click', start); });
    var rb = root.querySelector('[data-restart]'); if (rb) rb.addEventListener('click', function () { panels.forEach(function (p) { p.classList.remove('on'); }); start(); });

    S = fresh();
    (function () {
      var posted = !!root.querySelector('[data-posted]');
      var saved = null; try { saved = JSON.parse(sessionStorage.getItem('dsf_restore') || 'null'); } catch (x1) { saved = null; }
      if (posted && saved && typeof saved === 'object' && (typeof saved.w === 'number' || typeof saved.g === 'number')) {
        try { sessionStorage.removeItem('dsf_restore'); } catch (x2) {}
        S.weight = (typeof saved.w === 'number') ? saved.w : null;
        S.wLabel = (typeof saved.wl === 'string') ? saved.wl : null;
        S.girth = (typeof saved.g === 'number') ? saved.g : null;
        S.problems = (saved.p && Object.prototype.toString.call(saved.p) === '[object Array]') ? saved.p : [];
        S.context = (typeof saved.c === 'string') ? saved.c : null;
        S.bau = (typeof saved.b === 'string') ? saved.b : null;
        S.s2 = (saved.s2 && typeof saved.s2 === 'object') ? saved.s2 : {};
        S.orthoDiag = !!saved.od;
        finish(true);
        dl('finder_email_success', { recommended_product: lastPhys ? lastPhys.product : '' });
      } else if (posted) {
        try { sessionStorage.removeItem('dsf_restore'); } catch (x3) {}
        if (hero) hero.hidden = true; quiz.hidden = true; res.hidden = false;
        ['.dsf__diag', '.dsf__panels', '.dsf__after'].forEach(function (sel) { var hn = res.querySelector(sel); if (hn) hn.hidden = true; });
        var stk = res.querySelector('[data-sticky]'); if (stk) stk.hidden = true;
        setBar(100, '');
        dl('finder_email_success', {});
      }
    })();
  }
  function init() { var r = document.querySelectorAll('[data-dsf]'); for (var i = 0; i < r.length; i++) initRoot(r[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-dsf]'); if (r) initRoot(r); });
})();


/* ──────────────────────────────────────────────────────────────────────────
   Warenkorb direkt im Finder-Ergebnis. 28.07.2026.

   Anlass: 30 Sessions bekamen in der Woche 21. bis 27.07. eine fertige
   Groessenempfehlung, 20 klickten den Ergebnis-CTA, shopweit gab es aber nur
   27 Warenkoerbe. Zwischen Empfehlung und Kauf lag ein kompletter Seitenwechsel.

   Der Finder setzt den Varianten-Link bereits selbst (buildSwatches ->
   applyVariant). Dieser Block liest genau diesen href aus, statt Farb- und
   Groessenlogik ein zweites Mal zu bauen. Setzt applyVariant keine Variante,
   weil conf === 'niedrig' ist oder die Groesse ausserhalb der Palette liegt,
   erscheint auch kein Warenkorb-Button. Wer unsicher ist, soll nicht in den
   Kauf gedraengt werden, eine Retoure kostet mehr als der gesparte Klick bringt.

   Cross-Sell: Der Button legt nur das Geschirr ab und feuert danach
   'ajaxProduct:added'. Der Warenkorb oeffnet, und der bestehende
   Cross-Sell-Reminder blendet die passende Leine ein. Dessen Section
   (ds-cross-sell-reminder-data.liquid) rendert ohne Item-Count-Gate und zeigt
   den Reminder genau dann, wenn das Cross-Sell-Produkt noch nicht im Warenkorb
   liegt. Die Farb- und Groessenzuordnung der Leine passiert dort serverseitig.
   Bewusst kein zweiter Toggle im Ergebnis: das haette dieselbe Zuordnung ein
   drittes Mal nachgebaut und das Ergebnis auf dem Telefon aufgeblaeht.

   Nachlauf statt MutationObserver: Ein Beobachter auf dem Ergebnisbereich hat
   sich am 28.07. selbst ausgeloest, weil schon das erneute Setzen eines
   gleichen Textes als Mutation zaehlt. Deshalb hier ein billiger Intervall
   plus die Regel, dass jede Schreiboperation vorher auf Gleichheit prueft:
   sync() ist idempotent, ein zweiter Aufruf ohne fremde Aenderung fasst das
   DOM nicht an.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var STYLE_ID = 'dsf-atc-style';
  var CSS =
    '.dsf__atc{display:block;width:100%;box-sizing:border-box;margin:0 0 8px;padding:16px 20px;' +
    'border:0;border-radius:16px;background:#0071e3;color:#fff;font:600 17px/1.2 inherit;' +
    'text-align:center;cursor:pointer;-webkit-appearance:none;appearance:none;' +
    'transition:background 150ms ease,opacity 150ms ease;touch-action:manipulation}' +
    '.dsf__atc:hover{background:#0077ed}' +
    '.dsf__atc:disabled{opacity:.6;cursor:default}' +
    '.dsf__atc--ok{background:#1d1d1f}' +
    '[data-cta="pdp"].dsf__cta--sek{background:transparent!important;color:#0071e3!important;' +
    'border:0!important;box-shadow:none!important;font-size:15px!important;' +
    'padding:10px 16px!important;min-height:0!important}' +
    '@media (max-width:479px){.dsf__atc{padding:15px 16px;font-size:16px}}' +
    '@media (prefers-reduced-motion:reduce){.dsf__atc{transition:none}}';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function push(ev, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev }, k;
      if (data) for (k in data) o[k] = data[k];
      window.dataLayer.push(o);
    } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', ev, data || {}); } catch (e2) {}
  }

  function variantAus(href) {
    if (!href) return null;
    var m = String(href).match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  /* Jede Schreiboperation prueft vorher auf Gleichheit. Das haelt sync()
     idempotent und schliesst eine Rueckkopplung ueber DOM-Aenderungen aus. */
  function setText(el, wert) {
    if (el && el.textContent !== wert) el.textContent = wert;
  }
  function setClass(el, klasse, an) {
    if (!el) return;
    if (an && !el.classList.contains(klasse)) el.classList.add(klasse);
    else if (!an && el.classList.contains(klasse)) el.classList.remove(klasse);
  }

  function sichtbar(el) {
    return !!(el && el.offsetParent !== null);
  }

  function groessenLabel() {
    var ins = document.querySelector('.dsf__size .dsf__ins strong');
    var g = ins ? ins.textContent.replace(/^Größe\s*/i, '').trim() : '';
    return g ? ('Größe ' + g + ' in den Warenkorb') : 'In den Warenkorb';
  }

  function inDenWarenkorb(btn, cta) {
    // href erst im Klickmoment lesen: der Farbwaehler schreibt ihn laufend um
    var vid = variantAus(cta.getAttribute('href'));
    if (!vid) return;

    var label = btn.getAttribute('data-label') || 'In den Warenkorb';
    btn.disabled = true;
    btn.setAttribute('data-busy', '1');
    setText(btn, 'Einen Moment ...');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-DS-Source': 'geschirr-finder' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function (data) {
        push('finder_add_to_cart', {
          variant_id: parseInt(vid, 10),
          product: cta.getAttribute('data-product') || null
        });
        setClass(btn, 'dsf__atc--ok', true);
        setText(btn, 'Liegt im Warenkorb');

        // Warenkorb oeffnen. Dasselbe Ereignis nutzen Produktseite und
        // Cross-Sell. Danach greift der Cross-Sell-Reminder mit der Leine.
        try {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true, detail: { product: data, source: 'geschirr-finder' }
          }));
        } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e2) {}

        setTimeout(function () {
          setClass(btn, 'dsf__atc--ok', false);
          btn.disabled = false;
          btn.removeAttribute('data-busy');
          setText(btn, btn.getAttribute('data-label') || label);
        }, 2600);
      })
      .catch(function () {
        // Kein stiller Fehlschlag: der Kunde landet auf der Produktseite und
        // kann dort regulaer bestellen.
        btn.disabled = false;
        btn.removeAttribute('data-busy');
        setText(btn, label);
        window.location.href = cta.getAttribute('href');
      });
  }

  function ruesteAus(cta) {
    var panel = cta.parentNode;
    if (!panel) return;
    var vorhanden = panel.querySelector('.dsf__atc');
    var vid = variantAus(cta.getAttribute('href'));

    // Nur das sichtbare Panel ausruesten. Das Ergebnis haelt drei Panels vor
    // (Empfehlung, Alternative, Basic), und die Groessenangabe im Befund gilt
    // dem empfohlenen Produkt. Ein Button im verborgenen Panel truege sonst
    // eine Beschriftung, die dort nicht stimmen muss.
    // Ohne Variante ebenfalls kein Button: conf === 'niedrig'.
    if (!sichtbar(cta) || !vid) {
      if (vorhanden) vorhanden.parentNode.removeChild(vorhanden);
      setClass(cta, 'dsf__cta--sek', false);
      return;
    }

    ensureStyle();
    var label = groessenLabel();

    if (vorhanden) {
      if (vorhanden.getAttribute('data-label') !== label) {
        vorhanden.setAttribute('data-label', label);
        if (!vorhanden.getAttribute('data-busy')) setText(vorhanden, label);
      }
      setClass(cta, 'dsf__cta--sek', true);
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dsf__atc';
    btn.setAttribute('data-label', label);
    btn.textContent = label;
    btn.addEventListener('click', function () { inDenWarenkorb(btn, cta); });
    panel.insertBefore(btn, cta);

    setClass(cta, 'dsf__cta--sek', true);
    if (/ansehen/i.test(cta.textContent)) setText(cta, 'Erst die Produktseite ansehen');
  }

  function sync() {
    var ctas = document.querySelectorAll('[data-cta="pdp"]');
    for (var i = 0; i < ctas.length; i++) ruesteAus(ctas[i]);
  }

  function start() {
    sync();
    // Billiger Nachlauf statt Beobachter: der Finder schreibt href und
    // Panel-Sichtbarkeit beim Farbwechsel und beim erneuten Rendern um.
    setInterval(sync, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
